import { useState, useEffect } from 'react';
import { CustomFieldEnum, ICustomField, getAllCustomFieldsByEntity } from 'wisestep-api';

interface UseCustomFieldsResult {
  customFields: ICustomField[] | null;
  defaultFields: ICustomField[] | null;
  loading: boolean;
  error: Error | null;
  refresh: () => void;
}

export const useCustomFields = (entity: CustomFieldEnum): UseCustomFieldsResult => {
  const [customFields, setCustomFields] = useState<ICustomField[] | null>(null);
  const [defaultFields, setDefaultFields] = useState<ICustomField[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchFields = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await getAllCustomFieldsByEntity(entity);
      const defaultFieldsArray = data.filter((field: ICustomField) => field.isDefault === true);
      const customFieldsArray = data.filter((field: ICustomField) => !field.isDefault);

      setDefaultFields(defaultFieldsArray);
      setCustomFields(customFieldsArray);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFields();
  }, [entity]);

  return { customFields, defaultFields, loading, error, refresh: fetchFields };
};
